import { ListImage, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from './style';

type Props = {
  buildingId: string;
  buildingName: string;
  addressOfProperty: string;
  bluePrints?: {
    bluePrintUrl: string;
    title: string;
    _id: string;
  }[];
};

const BluePrints = ({ addressOfProperty, buildingName, bluePrints }: Props) => {
  // const navigate = useNavigate();

  // const navigateToBuilding = () => {
  //   navigate(BUILDING_ROUTE);
  // };

  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PROPERTY BLUEPRINTS INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Address of Property :</Typography>
          <Typography className="value">{addressOfProperty}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          {bluePrints?.map((img, idx) => {
            return (
              <div key={idx}>
                <ListImage
                  imagesURL={[
                    {
                      id: `${idx + 1}`,
                      URL: img.bluePrintUrl,
                    },
                  ]}
                  imageHeight="143px"
                  imageWidth="192px"
                />
              </div>
            );
          })}
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default BluePrints;
